import { useCSVDownloader } from 'react-papaparse'
import axios, { AxiosError } from 'axios'
import { Button } from 'semantic-ui-react'

import { ProductResponse } from '../../hooks/useProduct'
import { API_PRODUCTS } from '../../consts'
import Row from './Row'

const fetchProductCsv = async (productIds: string[]) => {
  let errors: AxiosError[] = []

  let newProductData: Row[] = []

  await Promise.all(
    productIds.map(async (id) => {
      try {
        const response = await axios.get<ProductResponse>(`${API_PRODUCTS}/${id}`)

        const productRow = {
          id: response.data.product.id.toString(),
          name: response.data.product.name,
          brand: response.data.product.brand,
          description: response.data.product.description,
          photo: '',
          lineage: response.data.product.lineage,
          product_type: response.data.product.kind,
          product_subtype: response.data.product.root_subtype,
          brand_subtype: response.data.product.brand_subtype,
          dosage: response.data.product.dosage?.toString(),
          amount: response.data.product.amount?.toString(),
        }

        newProductData.push(productRow)
      } catch (err) {
        if (axios.isAxiosError(err)) {
          errors.push(err)
        }
      }
    })
  )

  return newProductData
}

interface CSVDownloaderProps {
  productIds: string[]
}

export default function CSVDownloader({ productIds }: CSVDownloaderProps) {
  const { CSVDownloader: PapaDownloader } = useCSVDownloader()

  const TemplateDownloader = () => {
    const blankCSV = [
      {
        id: '',
        name: '',
        brand: '',
        description: '',
        photo: '',
        lineage: '',
        product_type: '',
        product_subtype: '',
        brand_subtype: '',
        dosage: '',
        amount: '',
      },
    ]

    return (
      <Button>
        <PapaDownloader
          filename={`clump_editor_export-${Date.now()}`}
          config={{ header: true }}
          data={blankCSV}
        >
          Download CSV template
        </PapaDownloader>
      </Button>
    )
  }

  if (productIds.length === 0) return <TemplateDownloader />

  return (
    <Button>
      <PapaDownloader
        filename={`clump_editor_template-${Date.now()}`}
        config={{ header: true }}
        data={async () => fetchProductCsv(productIds)}
      >
        Download CSV from queue
      </PapaDownloader>
    </Button>
  )
}
